module.exports = __webpack_public_path__ + "img/colored-vertical-bar-icon-21022022.ecb50717.svg";